import { render, staticRenderFns } from "./mono-no-auth.vue?vue&type=template&id=45470a62&scoped=true"
import script from "./mono-no-auth.vue?vue&type=script&lang=js"
export * from "./mono-no-auth.vue?vue&type=script&lang=js"
import style0 from "./mono-no-auth.vue?vue&type=style&index=0&id=45470a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45470a62",
  null
  
)

export default component.exports